import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useAuthStore } from '../stores/authStore';

export function ProtectedRoute({ role }: { role?: 'user' | 'admin' } = {}) {
  const { isAuthenticated, isLoading, checkSession, user } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    // Only check the session when the store shows unauthenticated — this covers
    // the "localStorage cleared but session cookie still valid" recovery case.
    // Skipping it when already authenticated prevents a stale in-flight
    // checkSession from overwriting a freshly-set sign-in state.
    if (!isAuthenticated) {
      checkSession();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) return null;
  if (!isAuthenticated) {
    const redirect = location.pathname + location.search;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />;
  }
  if (role === 'admin' && user?.role !== 'admin') {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="h5">Access denied</Typography>
        <Typography variant="body2" color="text.secondary">
          You do not have permission to view this page.
        </Typography>
      </Box>
    );
  }
  return <Outlet />;
}
